import OzonStatistics from '../../../../components/OzonStatistics';

export default OzonStatistics;
